import React, { useEffect, useState } from "react";
import api from "../../api";
import Layout from "../../components/Layout/Layout";

export default function OutletsList() {
  const [outlets, setOutlets] = useState([]);

  useEffect(() => {
    load();
    console.log(api.baseURL);
    
  }, []);

  const load = async () => {
    const res = await api.get("/api/outlets");
    setOutlets(res.data);
  };

  const removeOutlet = async (id) => {
    const ok = window.confirm("Are you sure you want to delete this outlet?");
    if (!ok) return;
    await api.delete(`/api/outlets/${id}`);
    load();
  };

  return (
    <div className="p-4 max-w-6xl mx-auto">

      {/* HEADER SECTION */}
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-800">Outlets</h1>
        <p className="text-gray-500">Manage all registered store/outlet locations.</p>
      </div>

      {/* OUTLETS TABLE */}
      <div className="overflow-hidden rounded-xl border border-gray-200 shadow bg-white">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200 text-gray-700">
              <th className="p-3 text-left font-semibold">Outlet Name</th>
              <th className="p-3 text-left font-semibold">City</th>
              <th className="p-3 text-left font-semibold">Actions</th>
            </tr>
          </thead>

          <tbody>
            {outlets.length === 0 && (
              <tr>
                <td colSpan="3" className="p-5 text-gray-500 text-center">
                  No outlets found.
                </td>
              </tr>
            )}

            {outlets.map((o) => (
              <tr
                key={o._id}
                className="border-b hover:bg-gray-50 transition"
              >
                <td className="p-3 text-gray-800">{o.name}</td>
                <td className="p-3 text-gray-600">{o.city}</td>

                <td className="p-3 flex gap-4">

                  {/* EDIT BUTTON */}
                  <button
                    className="text-blue-600 hover:text-blue-800 font-semibold"
                  >
                    Edit
                  </button>

                  {/* DELETE BUTTON */}
                  <button
                    className="text-red-600 hover:text-red-800 font-semibold"
                    onClick={() => removeOutlet(o._id)}
                  >
                    Delete
                  </button>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}
